// utils/certificateParser.js

// Український алфавіт (великі літери)
const ukrAlphabet = [
  'А', 'Б', 'В', 'Г', 'Ґ', 'Д', 'Е', 'Є', 'Ж', 'З', 'И', 'І', 'Ї',
  'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х',
  'Ц', 'Ч', 'Ш', 'Щ', 'Ь', 'Ю', 'Я'
];

const validSeries = ["І", "1", "ІІ"];

const generateAllSubSeries = () => {
  const combinations = [];
  for (let i = 0; i < ukrAlphabet.length; i++)
    for (let j = 0; j < ukrAlphabet.length; j++)
      combinations.push(ukrAlphabet[i] + ukrAlphabet[j]);
  return combinations;
};

const allSubSeries = generateAllSubSeries();

// Латинські омогліфи → українські відповідники
const latinToUkr = {
  'A': 'А', 'B': 'В', 'C': 'С', 'E': 'Е', 'H': 'Н', 'I': 'І',
  'K': 'К', 'M': 'М', 'O': 'О', 'P': 'Р', 'T': 'Т', 'X': 'Х',
  'Y': 'У',
};

/**
 * Нормалізація вхідного рядка:
 * - toUpperCase
 * - латинські омогліфи → кирилиця
 * - будь-які роздільники → '|' для подальшого tokenize
 */
const normalizeInput = (str) => {
  let s = str.trim().toUpperCase();
  s = s.split('').map(ch => latinToUkr[ch] || ch).join('');
  s = s.replace(/[-\s_.,]+/g, '|');
  return s;
};

/**
 * Парсинг свідоцтва про народження.
 *
 * Підтримувані формати вхідних даних:
 *   "І-БК 123456"     — канонічний (наш формат збереження)
 *   "1-АВ 766876"     — серія цифрою
 *   "ІІ-ВГ 000001"    — двобуквена серія
 *   "I-БK-098098"     — латинські омогліфи, дефіс замість пробілу
 *   "І БК 098098"     — пробіли замість дефісів
 *   "1 БК 098098"     — пробіли, серія цифрою
 *
 * Стратегія: токенізація по роздільниках, потім класифікація кожного токена.
 */
const parseCertificate = (certValue) => {
  const defaultValue = { series: "І", subSeries: "БК", number: "" };

  if (!certValue || typeof certValue !== 'string') {
    return defaultValue;
  }

  const norm = normalizeInput(certValue);
  const tokens = norm.split('|').filter(Boolean);

  let series = null;
  let subSeries = null;
  let number = '';

  for (const token of tokens) {
    const isDigitsOnly = /^\d+$/.test(token);
    const isUkrLetters = /^[АБВГҐДЕЄЖЗИІЇЙКЛМНОПРСТУФХЦЧШЩЬЮЯабвгґдеєжзиіїйклмнопрстуфхцчшщьюя]+$/.test(token);

    if (isDigitsOnly) {
      // "1" без серії — це серія; інші цифри — номер
      if (token === '1' && series === null) {
        series = '1';
      } else if (!number) {
        number = token.slice(0, 6);
      }
    } else if (isUkrLetters) {
      if (!series && validSeries.includes(token)) {
        series = token;
      } else if (!subSeries && token.length === 2 && allSubSeries.includes(token)) {
        subSeries = token;
      } else if (!subSeries && token.length > 2) {
        // Склеєний токен без роздільника між підсерією і номером: "БК098098"
        const sub = token.slice(0, 2);
        if (allSubSeries.includes(sub)) {
          subSeries = sub;
          const rest = token.slice(2).replace(/\D/g, '').slice(0, 6);
          if (rest && !number) number = rest;
        }
      }
    }
  }

  return {
    series: series || "І",
    subSeries: subSeries || "БК",
    number,
  };
};

/**
 * Форматування в канонічний рядок для збереження: "СЕРІЯ-ПІДСЕРІЯ НОМЕР"
 */
const formatCertificateString = (series, subSeries, number) => {
  if (!number) return `${series}-${subSeries}`;
  return `${series}-${subSeries} ${number}`;
};

/**
 * Валідація
 */
const isValidCertificate = (certString) => {
  const { series, subSeries, number } = parseCertificate(certString);
  return number.length === 6 && subSeries.length === 2 && validSeries.includes(series);
};

const getAllSubSeries = () => [...allSubSeries];
const getValidSeries = () => [...validSeries];

export {
  parseCertificate,
  formatCertificateString,
  isValidCertificate,
  getAllSubSeries,
  getValidSeries
};